import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../Context";
import Fetch, { Loader, user_login } from "../inc/Fetch";

import { Input } from "../components/Form";

import { MdArrowForwardIos, MdErrorOutline } from "react-icons/md";

import './css/Reset.css'

export default function Reset() {

    const { t } = useTranslation();
    const params = useParams();
    const navigation = useNavigate();

	const {siteData, cartData, successData} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;
	const [cart, setcart] = cartData;
	const [success, setsuccess] = successData;

    


    const [isLoading, setisLoading] = useState(true);
    const [loader, setloader] = useState(false);
    const [data, setdata] = useState([]);
    const [error, seterror] = useState(false);

    async function loadData() {
        let res = await Fetch('customers/reset_check', { code:params?.id }) ;
        setisLoading(false);
        
        if (res?.error) {
            seterror(res?.error);
        }
        
    }

    async function submit() {
        setloader(true);
        let res = await Fetch('customers/reset_check_active', { code:params?.id, pass:data?.pass, pass2:data?.pass2 }) ;
        setloader(false);
        
        if (res?.success) {
            setsuccess({ short: t("reset_success_text"), error: false });
            setTimeout(() => {
                navigation("/");
            }, 2500);
        } else {
            setsuccess({ short: res?.error, error: true });
        }
        
    }

    useEffect(() => {
        loadData();
    }, [])
    
    

    if (isLoading) {
        return <Loader />;
    }



	return (
		<>
            {loader && <Loader />}
            <Helmet>
                <title>{t("reset_success_title")}</title>
                <meta property="og:title" content={t("reset_success_title")}/>
            </Helmet>

			

            <nav className='mainWidth pathNames'> 
                <Link to='/'>{t("home")}</Link>
                <MdArrowForwardIos />
                <Link>{t("reset_success_title")}</Link>

            </nav>

            {!error ? 
                <div className='mainWidth resetBox'>
                    <h1>{t("reset_success_title")}</h1>
                    <h2>{t("reset_success_text2")}</h2>

                    <Input 
                        title={t("reset_new_pass")}
                        name="pass"
                        type="password"
                        autoFocus={true}
                        onChange={(r) => setdata(p => ({
                            ...p,
                            pass:r
                        }))}
                        value={data?.pass}
                    />

                    <Input 
                        title={t("reset_new_pass2")}
                        name="pass"
                        type="password"
                        onChange={(r) => setdata(p => ({
                            ...p,
                            pass2:r
                        }))}
                        value={data?.pass2}
                    />


                    <button onClick={submit} className='btn'>CHANGE PASSWORD</button>
        
                </div>
            : 
                <div className='mainWidth resetBox' style={{padding:"0px 0 15px 0"}}>
                    <div className='errorIconBox'>
                        <MdErrorOutline />
                    </div>
                    <p className='resetErrorText'>{error}</p>

                    <Link to='/' className='btn errorResetBtn'>{t("reset_return_home")}</Link>
                </div>
            }

		</>
	)
}
